import { execOnLoad } from '@general/helpers';
import './collection-slider.scss';
import Swiper from 'swiper';
import 'swiper/scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initCollectionSlider = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const slider = sectionContainer.querySelector(
    '.collection-slider__container',
  );
  if (!slider) return;

  const options = {
    loop:
      slider.classList.contains('collection-slider__container--loop') &&
      slider.querySelectorAll('.swiper-slide').length >= 2,
    slidesPerView: 1.5,
    centeredSlides: true,
    spaceBetween: 48,
    on: {
      init: function (swiper) {
        swiper.slideToLoop(0, 0);
      },
    },
  };

  new Swiper(slider, options);
};

execOnLoad(window.dAgency.initCollectionSlider, '.collection-slider__section');
